module.exports = __webpack_public_path__ + "static/media/registraceDPH.07fcd866.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/registraceDPH.pdf
// module id = 380
// module chunks = 0